export const ACCOUNT_USER_TYPE_SYSTEM_ADMIN: string = 'system-admin';
export const ACCOUNT_USER_TYPE_ADMIN: string = 'admin';
export const ACCOUNT_USER_TYPE_REGULAR: string = 'regular';
export const ACCOUNT_USER_TYPE_CONSULTANT: string = 'consultant';
export const ACCOUNT_USER_TYPE_LIMITED_PARTNER: string = 'limited-partner';
export const ACCOUNT_USER_TYPE_EXTERNAL_LIMITED_PARTNER: string = 'external-limited-partner';
export const ACCOUNT_USER_TYPE_INVESTOR: string = 'investor';
